/**
 * @desc WMS出库结果处理
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.FulfilmentOutRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/fulfilment/out`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
